import axios from 'axios';
import qs from 'qs';
import { LS_AUTH_TOKEN } from './constants';

const TIMEOUT = 60 * 1000 * 5;
// const BASE_URL = '/api/';

axios.defaults.timeout = TIMEOUT;
// axios.defaults.baseURL = BASE_URL;
axios.defaults.withCredentials = false;
axios.defaults.paramsSerializer = (params) => qs.stringify(params, { skipNulls: true });

const setupAxiosInterceptors = (onUnauthenticated, onAccessDenied) => {
    const onRequestSuccess = (config) => {
        const token = sessionStorage.getItem(LS_AUTH_TOKEN);
        if (token) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Bearer ${token}`;
        }
        // eslint-disable-next-line no-param-reassign
        config.timeout = TIMEOUT;
        // config.url = `${(BASE_URL || '').replace(/\/$/, '')}${config.url}`;
        return config;
    };

    const onResponseSuccess = (response) => response;

    const onResponseError = (err) => {
        const status = err.status || (err.response ? err.response.status : 0);
        if (status === 401) {
            onUnauthenticated();
        } else if (status === 403) {
            onAccessDenied(err.config.url.replace(window.location.origin, ''));
        }
        return Promise.reject(err);
    };

    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export default setupAxiosInterceptors;
